import React from "react";
import {
	Box,
	TextField,
	FormControl,
	InputAdornment,
	InputLabel,
	Input,
	IconButton,
	Button,
	Typography,
	Select,
	MenuItem,
	FormHelperText,
	Alert,
	Tabs,
	Tab,
	Stack,
	Modal as MuiModal,
} from "@mui/material";
import {
	AccountCircleOutlined,
	Visibility,
	VisibilityOff,
	LockOutlined,
	Group,
	Close as CloseIcon,
	IosShareOutlined
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set, range } from "lodash";
import { Grid } from "../../../components/table";
import { CONFIG } from "../../../../config";
import axios from "axios";
import { ToolBar } from "../../../components/toolbar";
import { Modal } from "../../../components/modal";
import { FormA } from "../../../components/form";
import moment from "moment";
import { getFormState } from "../../../../helpers/form";

import { toast } from "react-hot-toast";
import dayjs from "dayjs";
import { filterColumns } from "../column-manager";
import SelectedAssignDialog from "./features/selected-assign-dialog";

import IosShareIcon from "@mui/icons-material/IosShare";
import PropTypes from 'prop-types';
const durationPulgin = require('dayjs/plugin/duration')
dayjs.extend(durationPulgin)


const API_HOST = CONFIG.modules["accounts"].host;
const API_HOST_CRM = CONFIG.modules["crm"].host;

const centeredMuiModalStyle = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: {
		xs: 3 / 4,
		md: 1 / 2,
		lg: 1 / 3,
	},
	bgcolor: "background.paper",
	border: "2px solid #000",
	borderRadius: 2,
	boxShadow: 24,
	p: 4,
};

function CustomTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 1 }}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

CustomTabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}


const getTotalWeekOfCurrentMonth = () => {
	return Math.ceil(dayjs().daysInMonth() / 7)
}

const getWeekOfMonth = () => {
	return dayjs.duration().weeks();
}

export const ActiveHighPriority = (props) => {
	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	return (
		<Box sx={{ width: '100%' }}>
			<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
				<Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
					<Tab label="Due Today (40 days)" {...a11yProps(0)} />
					<Tab label="Due Today (90 days)" {...a11yProps(1)} />
					<Tab label="Call Overdue (40 days)" {...a11yProps(2)} />
					<Tab label="Call Overdue (90 days)" {...a11yProps(3)} />
				</Tabs>
			</Box>
			<CustomTabPanel value={value} index={0}  >
				<List heading={''} sx={{ fontSize: '.1em' }} type={'due-today-40'} socket={props.socket} />
			</CustomTabPanel>
			<CustomTabPanel value={value} index={1}  >
				<List heading={''} type={'due-today-90'} socket={props.socket} />
			</CustomTabPanel>
			<CustomTabPanel value={value} index={2}  >
				<List heading={''} type={'overdue-40'} socket={props.socket} />
			</CustomTabPanel>
			<CustomTabPanel value={value} index={3}  >
				<List heading={''} type={'overdue-90'} socket={props.socket} />
			</CustomTabPanel>
		</Box>
	)
}

export const List = ({ heading, type, socket }) => {
	const {
		roles,
		user,
		users,
		Designations,
		Departments,
		Languages,
		Districts,
		map
	} = useSelector((state) => state.user || {});
	const userStore = useSelector((state) => state.user || {});
	console.log('length', dayjs.duration().asWeeks())

	const [listLoading, setListLoading] = useState(false);

	const [active, setActive] = useState("Employees");
	const [data, setData] = useState([]);
	const [open, setOpen] = useState(false);
	const [action, setAction] = useState("new");
	const [saved, setSaved] = useState(null);
	const [index, setIndex] = useState(null);
	const [openConfirm, setOpenConfirm] = useState(false);
	const [assigning, setAssigning] = useState(false);
	const [assignCompleted, setAssignCompleted] = useState(false)

	/**
	 * States and methods required for the selective assign modal
	 */
	const [selectedRows, setSelectedRows] = useState([]);
	const [staticSelectedRows, setStaticSelectedRows] = useState(new Map());
	const [needToBeUnassignedCases, setNeedToBeUnassignedCases] = useState(new Map());
	const [activeSelectedAssign, setActiveSelectedAssign] = useState(null);
	const [assignSelectedCompleted, setAssignSelectedCompleted] = useState(false);
	const [assigningSelected, setAssigningSelected] = useState(false);
	const [isUnassigning, setIsUnassigning] = useState(false);
	const [isFetchingSelectedCasesDetails, setIsFetchingSelectedCasesDetails] = useState(false);
	const [selectedAgents, setSelectedAgents] = useState([]);
	const [openAssignSelected, setOpenAssignSelected] = useState(false);

	const assignSelectedCases = async () => {
		if (staticSelectedRows.size == 0) {
			toast.error("No cases selected");
			return;
		}

		const canBeAllocated = await selectedRowsThatCanBeAllocated();

		if (canBeAllocated.size > 0) {
			setNeedToBeUnassignedCases(canBeAllocated);
		} else {
			setActiveSelectedAssign("selected-agent");
			setAssignSelectedCompleted(false);
		}
	};

	const selectedRowsThatCanBeAllocated = async () => {
		let newNeedUnassignedMap = new Map();

		const caseIds = Array.from(staticSelectedRows.keys());
		const motherIds = caseIds.map((caseId) => {
			return staticSelectedRows.get(caseId)?.motherID;
		});
		const uniqueMotherIds = [...new Set(motherIds)];

		try {
			setIsFetchingSelectedCasesDetails(true);
			const result = await axios.post(
				API_HOST_CRM + "/ecd/selected-cases-details/mother-ids",
				{
					cases: uniqueMotherIds,
				},
			);

			if (result.data.success) {
				const cases = result.data.cases;
				let newStaticSelectedRows = new Map(staticSelectedRows);

				Array.from(newStaticSelectedRows.values()).map(staticCase => {
					let staticSelectedCase = staticCase;
					let staticCaseMotherId = staticSelectedCase.motherID;
					let matchingMotherIDinQueueCase = cases.find(kase => ((kase.motherID === staticCaseMotherId) && kase.status === "Queue"))

					if (matchingMotherIDinQueueCase) {
						newStaticSelectedRows.delete(staticSelectedCase._id);
						newStaticSelectedRows.set(matchingMotherIDinQueueCase._id, matchingMotherIDinQueueCase)
					}
				})

				setStaticSelectedRows(newStaticSelectedRows);

				cases.forEach((e) => {
					if (e.status !== "Queue") {
						newNeedUnassignedMap.set(e._id, e);
					}
				});
			}
		} catch (error) {
			toast.error("Error in fetching selected cases details");
			console.log(error);
		} finally {
			setIsFetchingSelectedCasesDetails(false);
		}

		if (newNeedUnassignedMap.size > 0) {
			setNeedToBeUnassignedCases(newNeedUnassignedMap);
			toast(`${newNeedUnassignedMap.size} rows need to be unallocated `);
		}

		return newNeedUnassignedMap;
	};

	const unassignSelectedRows = async () => {
		setIsUnassigning(true);

		const resp = await axios
			.put(API_HOST_CRM + "/ecd/unassign-pendings", {
				caseIds: Array.from(needToBeUnassignedCases.keys()),
				reason: "66b1a4f1999b4aa3b0a6e170",
			})
			.catch((e) => {
				console.log(e);
				toast.error("Network Request Error in unassigning cases");
				setIsUnassigning(false);
			});

		if (resp.data && resp.data.success) {
			getList(true);

			toast.success(`${needToBeUnassignedCases.size} cases unallocated`, {
				position: "top-center",
				duration: 3800,
			});
			toast.success("Unassigned Successfully", {
				position: "top-center",
				duration: 3800,
			});
			setNeedToBeUnassignedCases(new Map());
			let newStaticSelectedRows = new Map(staticSelectedRows);

			const newCreatedCases = resp.data.newCreatedCases;
			if (!newCreatedCases) {
				toast.error("Data not received. Error in unassigning cases", {
					position: "top-center",
					duration: 3800,
				});
				setIsUnassigning(false);
				return;
			}

			Array.from(newStaticSelectedRows.values()).forEach((item) => {
				const matchingCase = newCreatedCases.find(
					(c) => c.motherID === item.motherID,
				);
				if (matchingCase) {
					newStaticSelectedRows.delete(item._id);
					newStaticSelectedRows.set(matchingCase._id, matchingCase);
				}
			});

			setStaticSelectedRows(newStaticSelectedRows);
		}
		setIsUnassigning(false);
	};

	const handleRemoveStaticSelection = (id, motherID) => {
		setStaticSelectedRows((prevStaticSelectedRows) => {
			const newStaticSelectedRows = new Map(prevStaticSelectedRows);
			const matchingCase = Array.from(newStaticSelectedRows.values()).filter(
				(data) => data.motherID === motherID
			)[0];

			if (matchingCase) {
				newStaticSelectedRows.delete(matchingCase._id);
			}
			return newStaticSelectedRows;
		});
	};

	// END states and methods required for the selective assign modal

	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(25);
	const [count, setCount] = useState(0);
	const [selectedSankalpData, setSelectedSankalpData] = useState(null);
	const [filter, setFilter] = useState({
		from: null,// dayjs("01-01-2023"),
		to: null,//dayjs(),
		cfrom: null,
		cto: null,
		week: getWeekOfMonth()
	});

	// EXPORT RELATED
	const [exportAllocationOpen, setExportAllocationOpen] = useState(false);
	const [exportDateRange, setExportDateRange] = useState({
		from: dayjs().format("YYYY-MM-DD"),
		to: dayjs().format("YYYY-MM-DD"),
	});
	const [exportLoading, setExportLoading] = useState(false);

	const handleExportAllocationOpen = () => {
		setExportAllocationOpen(true);
	};
	const handleExportAllocationClose = () => {
		setExportAllocationOpen(false);
	};

	const handleExportAllocation = () => {
		setExportLoading(true);
		axios
			.get(
				API_HOST_CRM +
				`/case-exporty-by-range?from=${exportDateRange.from ? exportDateRange.from : ""
				}&to=${exportDateRange.to ? exportDateRange.to : ""}&type=${type}`,
				{
					responseType: "blob",
				}
			)
			.then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute(
					"download",
					`allocations_${exportDateRange.from}_to_${exportDateRange.to}.xlsx`
				);
				document.body.appendChild(link);
				link.click();
				link.remove();
				toast.success("Allocations exported successfully");
				handleExportAllocationClose();
			})
			.catch((e) => {
				console.error("Error exporting allocations:", e);
				toast.error("Error exporting allocations");
			})
			.finally(() => {
				setExportLoading(false);
			});
	};

	useEffect(() => {
		console.log(filter)
	}, [filter])


	useEffect(() => {
		if (socket) {
			socket.on("case-update", (data) => {
				getList(true);
			})
		}
		return () => {
			if (socket) {
				socket.removeAllListeners();
			}
		}
	}, [socket])


	const getList = (keep) => {
		if (!keep) {
			setData([]);
		}
		setListLoading(true);

		axios
			.get(
				API_HOST_CRM +
				`/cases?limit=${rowsPerPage}` +
				`&page=${page}&type=${type}` +
				`${filter.from
					? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}`
					: ""
				}` +
				`${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""}` +
				`${filter.status ? `&status=${encodeURIComponent(JSON.stringify(filter.status))}` : ""}` +
				`${filter.district ? `&district=${encodeURIComponent(JSON.stringify(filter.district))}` : ""}` +
				`${filter.dataType ? `&dataType=${encodeURIComponent(JSON.stringify(filter.dataType))}` : ""}` +
				// `${filter.status ? `&status=${filter.status}` : ""}` +
				// `${filter.district ? `&district=${filter.district}` : ""}` +
				`${filter.motherID ? `&motherId=${filter.motherID}` : ""}` +
				`${filter.motherName ? `&motherName=${filter.motherName}` : ""}` +
				`${filter.contact ? `&contact=${filter.contact}` : ""}` +
				`${filter.motherStatus ? `&motherStatus=${encodeURIComponent(JSON.stringify(filter.motherStatus))}` : ""}` +

				// `${filter.telecaller ? `&telecaller=${filter.telecaller}` : ""}` +
				`${filter.telecaller ? `&telecaller=${encodeURIComponent(JSON.stringify(filter.telecaller))}` : ""}` +

				`${filter.allocatedToUser ? `&allocatedToUser=${encodeURIComponent(JSON.stringify(filter.allocatedToUser))}` : ""}` +

				`${filter.dateReceived ? `&dateReceived=${filter.dateReceived}` : ""
				}` +
				`${filter.cfrom
					? `&cfrom=${dayjs(filter.cfrom).format("YYYY-MM-DD")}`
					: ""
				}` +
				`${filter.cto ? `&cto=${dayjs(filter.cto).format("YYYY-MM-DD")}` : ""
				}` +
				`${filter.week ? `&week=${filter.week}` : ""}` +
				`${filter.priority ? `&priority=${encodeURIComponent(JSON.stringify(filter.priority))}` : ""}`

			)
			.then((resp) => {
				if (resp.data && resp.data.success) {
					setData(resp.data.cases);
					setCount(resp.data.count);
				}
			})
			.catch((e) => {
				console.log(e);
			})
			.finally(() => {
				setListLoading(false);
			});
	};

	useEffect(() => {
		getList();
	}, [page, rowsPerPage, filter]);

	useEffect(() => {
		getList();
	}, []);

	const exportMotherReport = (data) => {
		axios
			.get(
				API_HOST_CRM +
				`/export-motherData?id=${data.motherID}&from=${encodeURIComponent(
					dayjs(filter.from).format("YYYY-MM-DD")
				)}&to=${encodeURIComponent(dayjs(filter.to).format("YYYY-MM-DD"))}
				
				`,
				{
					responseType: "arraybuffer",
				}
			)
			.then((resp) => {
				if (resp) {
					const url = window.URL.createObjectURL(new Blob([resp.data]));
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute(
						"download",
						`Mother_Report_${data.motherID}+${data.name}.xlsx`
					);
					document.body.appendChild(link);
					link.click();
					console.log(resp);
					link.remove();
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};

	return (
		<>

			<ToolBar
				name={heading}
				height={'3em'}

				onClearFilter={() => {
					setFilter({
						from: null,
						to: null,
						cfrom: null,
						cto: null,
						firstReceived: null,
						motherName: '',
						motherID: '',
						contact: '',
						status: null,
						motherStatus: null,
						telecaller: null,
						district: null,
					})
				}}
				buttons={[
					{
						name: "Export Allocations",
						icon: () => <IosShareOutlined sx={{ fontSize: "1.2em" }} />,
						onClick: () => {
							handleExportAllocationOpen();
						},
					},
					{
						name: "Assign Selected",
						onClick: () => {
							setOpenAssignSelected(true);
						},
					},
				]}
				filters={[
					{
						field: {
							name: "from",
							type: "date",
							label: "Assign From",
						},
						onChange: (name, value) => {
							filter[name] = value;
							setFilter({ ...filter });
						},
						state: filter,
					},
					{
						field: {
							name: "to",
							type: "date",
							label: "Assign To",
						},
						onChange: (name, value) => {
							filter[name] = value;
							setFilter({ ...filter });
						},
						state: filter,
					},


				]}
			/>
			<Box sx={{ mt: 2 }}>
				<Grid
					isLoading={listLoading}
					data={data}
					// filter={filter}
					onSelectChange={(selected) => {
						setSelectedRows(selected);
					}}
					setStaticSelectedRows={setStaticSelectedRows}
					staticSelectedRows={staticSelectedRows}
					columns={[
						...filterColumns(
							[
								{
									id: "motherID",
									showFilter: true,
								},
								{
									id: "name",
									showFilter: true,
								},
								{
									id: "contact",
									showFilter: true
								},
								{
									id: "districtName",
									showFilter: true,
									type: "select"
								},

								// {
								//   id: "dateReceived",
								//   showFilter: true,
								// },
								{
									id: "lastCallDate",
									showFilter: true
								},


								{
									id: "allocatedToUser",
									// showFilter: true,
									isSelect: true
								},
								{
									id: "callDate",
									showFilter: false
								},
								{
									id: "priority",
									showFilter: true,
									type: "select"
								},





							],
							filter,
							setFilter,
							{ Districts, users, map }
						),
					]}
					pagination={{
						rowsPerPageOptions: [10, 25, 50],
						page,
						rowsPerPage,
						onPageChange: (event, newPage) => {
							setPage(newPage);
						},
						onRowsPerPageChange: (event) => {
							setRowsPerPage(+event.target.value);
							setPage(0);
						},
						count,
					}}
				></Grid>
			</Box>

			<Modal
				open={open}
				handleClose={() => {
					setOpen(false);
				}}
				head={`Sankalp Data`}
				buttons={[
					{
						name: "Cancel",
						onClick: () => {
							setOpen(false);
						},
					},
				]}
			>
				{selectedSankalpData &&
					selectedSankalpData.sankalpData &&
					Object.keys(selectedSankalpData.sankalpData).map((s, i) => {
						const map = {
							'pregStatus': 'Pregnancy Status',
							'advice': 'Advice',
							'pregnancyNumber': 'Pregnancy Number',
							'pretermDelivery': 'Pre-term Delivery',
							'nearResidance': 'Near By Residence',
							'trimester': 'Trimester'
						}
						return (
							<Box key={i} sx={{ display: 'flex', mt: 1 }}>
								<Typography variant='p'>{(map[s] || s)}: </Typography>&nbsp;
								<Typography variant='p' sx={{ color: 'grey', fontSize: '.9em' }}>{selectedSankalpData.sankalpData[s]}</Typography>
							</Box>
						)
					})
				}
			</Modal>

			<MuiModal
				open={exportAllocationOpen}
				onClose={handleExportAllocationClose}
				aria-labelledby="modal-title"
				aria-describedby="modal-description"
			>
				<Box sx={centeredMuiModalStyle}>
					<IconButton
						aria-label="close"
						onClick={handleExportAllocationClose}
						sx={{
							position: "absolute",
							right: 8,
							top: 8,
							color: (theme) => theme.palette.grey[500],
						}}
					>
						<CloseIcon />
					</IconButton>
					<Typography id="modal-title" variant="h6" component="h2">
						Export Allocations
					</Typography>
					<Stack
						direction="column"
						spacing={2}
						sx={{
							p: 2,
							border: "2px solid #e0e0e0",
							borderRadius: 2,
						}}
					>
						<Stack direction="column">
							<Typography>Select Date Range</Typography>
							<Stack direction="row" spacing={2} justifyContent="center" pt={1}>
								<TextField
									label="From"
									type="date"
									value={exportDateRange.from}
									onChange={(e) => {
										setExportDateRange({
											...exportDateRange,
											from: e.target.value,
										});
									}}
								/>
								<TextField
									label="To"
									type="date"
									value={exportDateRange.to}
									onChange={(e) => {
										setExportDateRange({
											...exportDateRange,
											to: e.target.value,
										});
									}}
								/>
							</Stack>
						</Stack>
						<Stack direction="row" spacing={2} justifyContent="center">
							<Button
								onClick={handleExportAllocation}
								variant="contained"
								disabled={exportLoading}
							>
								{exportLoading ? "Exporting..." : "Export"}
							</Button>
						</Stack>
					</Stack>
				</Box>
			</MuiModal>

			{/* MODAL FOR SElective assign */}
			<SelectedAssignDialog
				open={openAssignSelected}
				handleClose={() => {
					setOpenAssignSelected(false);
				}}
				staticSelectedRows={staticSelectedRows}
				setStaticSelectedRows={setStaticSelectedRows}
				activeSelectedAssign={activeSelectedAssign}
				setActiveSelectedAssign={setActiveSelectedAssign}
				assignSelectedCases={assignSelectedCases}
				isFetchingSelectedCasesDetails={isFetchingSelectedCasesDetails}
				needToBeUnassignedCases={needToBeUnassignedCases}
				setNeedToBeUnassignedCases={setNeedToBeUnassignedCases}
				unassignSelectedRows={unassignSelectedRows}
				isUnassigning={isUnassigning}
				handleRemoveStaticSelection={handleRemoveStaticSelection}
				assignSelectedCompleted={assignSelectedCompleted}
				assigningSelected={assigningSelected}
				setAssigningSelected={setAssigningSelected}
				setAssignSelectedCompleted={setAssignSelectedCompleted}
				selectedAgents={selectedAgents}
				setSelectedAgents={setSelectedAgents}
				users={users}
				getList={getList}
			/>
		</>
	);
};
